import store from '@/store';

// LPD-3846: block edit modals for SSO users when VUE_APP_CP_SSO_HIDE_ACCOUNT_DETAILS is on.
export default () => {
    return store.dispatch('get_sso_hide_account_details').then(() => ({
        allow: !store.getters.is_sso_account_details_locked,
        redirect: { name: 'profile-personal-data' },
    }))
};
